/** Network-only navigation recovery; no install prompt, cache or reload of an open editor. */
export function registerInstallationWorker(): void {
  if (!("serviceWorker" in navigator) || !window.isSecureContext) return;
  void navigator.serviceWorker.register("/sw.js", { scope: "/", updateViaCache: "none" }).catch(() => {
    // The normal online application remains usable when installation support is unavailable.
  });
}
